import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { CabinetService } from '@cabinet/cabinet.service';
import * as fromRoot from '@core/redux/index';
import * as TaskActions from '@core/redux/task/task.actions';
import { Store } from '@ngrx/store';
import { MarkdownService } from 'ngx-markdown';

import { TaskListComponent } from '../task-list/task-list.component';
import { TaskViewComponent } from '../task-view/task-view.component';

@Component({
  selector: 'app-view-table',
  templateUrl: './view-table.component.html',
  imports: [NgClass, CommonModule, TaskViewComponent, TaskListComponent],
  standalone: true,
  providers: [MarkdownService],
  styleUrls: ['./view-table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewTableComponent {
  private route = inject(ActivatedRoute);
  private store = inject<Store<fromRoot.State>>(Store);
  private cabinetService: CabinetService = inject(CabinetService);
  private destroyRef = inject(DestroyRef);

  /** Открыт ли сайдбар задачи **/
  isOpenTask = signal<boolean>(false);

  /** Офсет при подгрузке задач */
  offset = signal<number>(0);

  /** Лимит загрузки задач за раз */
  readonly limit = 20;

  constructor() {
    this.cabinetService.layout = 'table';
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this._toggleTask(params['id']);
    });
  }

  onParticleLoad() {
    this.offset.update(value => value + this.limit);
  }

  private _toggleTask(id: string | null) {
    this.isOpenTask.set(!!id);
  }
}
